import React, { Component } from "react";
import './App.css';
import './index.css';
import TitlebarWithControls from "./TitlebarWithControls";
import MusicLogTable from "./logs/MusicLogTable";
import TrafficLogTable from "./logs/TrafficLogTable";
import { apiUrl } from './config';
import { getUser } from './UserStore';

// const grid = 1;

// const getItemStyle = (isDragging, draggableStyle) => ({
//   // some basic styles to make the items look a bit nicer
//   userSelect: "none",
//   padding: grid,
//   margin: `0 0 ${grid}px 0`,
//   fontWeight: "bold", 
//   borderRadius: "0.375rem",

//   // change background colour if dragging
//   color: isDragging ? "white" : "black",
//   background: isDragging ? "lightgreen" : "white",

//   // styles we need to apply on draggables
//   ...draggableStyle
// });

// const getMarkerStyle = () => ({
//     // some basic styles to make the items look a bit nicer
//     userSelect: "none",
//     padding: grid,
//     margin: `0 0 ${grid}px 0`,
//     fontWeight: "bold", 
  
//     // change background colour if dragging
//     color: "grey",
//   });

class LogTable extends Component {

  constructor(props) {
    super(props);

    // logdate
    const log_date = props.log_date ? props.log_date : new Date().toISOString().split('T')[0];    

    this.state = {
        logdate: log_date,
      logs: {},
      logDataFromApi: null,
      verifiedByUser: false,
      isLogGenerated: false,
      trafficEntries: [],
      isSubmitting: false,
      hasDraggedTrafficEntry: false,
      toastMessage: '',
      toastData: null,
      toastType: 'status',
      isLogSubmitted: false
    };

  }

  getDateOnlyValue = (dateValue) => {
    if (!dateValue) {
      return null;
    }

    if (typeof dateValue === 'string') {
      const dateMatch = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (dateMatch) {
        const year = Number(dateMatch[1]);
        const month = Number(dateMatch[2]);
        const day = Number(dateMatch[3]);
        return new Date(year, month - 1, day);
      }
    }

    const parsedDate = new Date(dateValue);
    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
  }

  toUtcStartOfDayISOString = (dateValue) => {
    if (!dateValue) {
      return new Date().toISOString();
    }

    if (typeof dateValue === 'string') {
      const dateMatch = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (dateMatch) {
        const year = dateMatch[1];
        const month = dateMatch[2];
        const day = dateMatch[3];
        return `${year}-${month}-${day}T00:00:00.000Z`;
      }
    }

    const dateOnly = this.getDateOnlyValue(dateValue);
    if (!dateOnly) {
      return new Date().toISOString();
    }

    const year = dateOnly.getFullYear();
    const month = String(dateOnly.getMonth() + 1).padStart(2, '0');
    const day = String(dateOnly.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000Z`;
  }

  isCurrentOrPastLogDate = () => {
    const logDate = this.getDateOnlyValue(this.state.logdate);
    if (!logDate) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return logDate <= today;
  }

  isCurrentLogDate = () => {
    const logDate = this.getDateOnlyValue(this.state.logdate);
    if (!logDate) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return logDate.getTime() === today.getTime();
  }

  isPastLogDate = () => {
    const logDate = this.getDateOnlyValue(this.state.logdate);
    if (!logDate) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return logDate < today;
  }

  isSubmitLocked = () => {
    return this.isPastLogDate();
  }

  getExistingLogId = () => {
    return this.state.logDataFromApi?.id?.$oid ||
      this.state.logDataFromApi?._id?.$oid ||
      this.state.logDataFromApi?.id ||
      this.state.logDataFromApi?._id;
  }

  getStationCall = () => {
    return 'KYRK';
  }

  showToast = (message, type = 'status') => {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }

    this.setState({ toastMessage: message, toastData: null, toastType: type });
    this.toastTimer = setTimeout(() => {
      this.setState({ toastMessage: '', toastType: 'status' });
    }, 2500);
  }

  showUploadToast = (data) => {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }

    this.setState({ toastData: data, toastMessage: '' });
    this.toastTimer = setTimeout(() => {
      this.setState({ toastData: null });
    }, 4000);
  }

  componentWillUnmount() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  handleUpload = async () => {
    const stationCall = this.getStationCall();

    this.showToast('Upload started...');
    this.setState({ isSubmitting: true });

    try {
      const response = await fetch(apiUrl('/runlog/upload'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          log_run_date: this.toUtcStartOfDayISOString(this.state.logdate),
          station_call: stationCall,
          log_type: this.state.logType || 'traffic'
        })
      });

      const text = await response.text();
      let data = null;
      try {
        data = JSON.parse(text);
      } catch (_) {
        // server returned plain text
      }

      if (response.ok && data && data.filename) {
        this.showUploadToast(data);
      } else {
        const msg = data?.message || text || `Upload failed (${response.status})`;
        this.showToast(msg, 'error');
      }
    } catch (error) {
      console.error('Upload error:', error);
      this.showToast('Upload failed: ' + error.message, 'error');
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

    // Date change listener function
  handleDateChange = async (event) => {
    const selectedDate = event.target.value;
    
    // Set loading state
    this.setState({ 
      logdate: selectedDate,
      loading: true,
      logs: {},
      logDataFromApi: null,
      trafficEntries: [],
      isLogGenerated: false,
      verifiedByUser: false,
      hasDraggedTrafficEntry: false,
      isLogSubmitted: false
    });

    try {
      // Load files/data for the selected date
      if (!this.state.logType) {
        this.setState({ logType: 'traffic' }); // Default to traffic if no type
      }
      await this.loadLogData(selectedDate, this.state.logType);
    } catch (error) {
      console.error('Error loading log data:', error);
    } finally {
      this.setState({ loading: false });
    }
  }

    // Log type change listener function
  handleLogTypeChange = async (event) => {
    const selectedType = event.target.value;
    
    // Set loading state
    this.setState({ 
      logType: selectedType,
      loading: true,
      logs: {},
      logDataFromApi: null,
      trafficEntries: [],
      isLogGenerated: false,
      verifiedByUser: false,
      hasDraggedTrafficEntry: false
    });

    try {
      if (!this.state.logdate) {
        this.setState({ logdate: new Date().toISOString().split('T')[0] }); // Default to today if no date
      }
      // Load files/data for the selected type
      await this.loadLogData(this.state.logdate, selectedType);
    } catch (error) {
      console.error('Error loading log data:', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  // Function to load log data for a specific date
  loadLogData = async (date, type) => {
   try {
    // clear logs at the start of the function 
    this.setState({ logs: {}, logDataFromApi: null, isLogSubmitted: false }); // Reset logs and items

    // Make API call to fetch log data for the selected date
    const response = await fetch(apiUrl(`/runlog/bydate`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        log_run_date: this.toUtcStartOfDayISOString(date),
        log_type: type
      })
    });
    
    if (!response.ok) {
      console.log('Response status:', response.status); // Debug log

      const errorText = await response.text();
      console.error('Error response:', errorText);

      throw new Error(`HTTP error! status: ${response.status}`);
    }
      
    var logDataFromApi = await response.json();

    this.setState({ logDataFromApi });

    console.log('Log data received:', logDataFromApi); // Debug log
      
    // Extract log_data and ensure it's properly parsed
    let logData = {};
    this.setState({ items: {}, logs: {} }); // Reset items and logs
    
    if (logDataFromApi && logDataFromApi.log_data) {
        try {
            console.log('Parsing log_data:', logDataFromApi.log_data); // Debug log
            logData = JSON.parse(logDataFromApi.log_data);
            if (logDataFromApi.log_type === 'music') {
                console.log('Setting music log data:', logData);
                this.setState({ items: {}, logs: logData }); // Store logs in state
            } else if (logDataFromApi.log_type === 'traffic') {
                console.log('Setting traffic log data:', logData);
              this.setState({
                items: {},
                logs: logData,
                trafficEntries: Array.isArray(logData?.entries) ? logData.entries : []
              }); // Store logs in state
            } else {
                console.warn('Unknown log type:', logDataFromApi.log_type);
                this.setState({ items:{}, logs: {} }); // Reset logs if unknown type
            }
            console.log('Processed log data array:', logData); // Debug log
        } catch (parseError) {
            console.error('Failed to parse log_data JSON:', parseError);
            this.setState({ logs: {} }); // Reset to empty on error
        }
                
        console.log('Log data loaded for date:', date);      
    }
   } catch (error) {
      console.error('Error loading log data:', error);
    this.setState({ logs: {}, items: {}, logDataFromApi: null }); // Reset to base markers on error
    }
 }

  handleTrafficLogUpdated = (entries) => {
    const safeEntries = Array.isArray(entries) ? entries : [];
    this.setState((prevState) => ({
      trafficEntries: safeEntries,
      logs: {
        ...(prevState.logs || {}),
        entries: safeEntries
      }
    }));
  }

  handleSaveAndSubmit = async () => {
    if (this.state.logType !== 'traffic' || this.state.isSubmitting || this.isSubmitLocked()) {
      return;
    }

    const storeUser = getUser();
    const username = storeUser?.authResponse?.profile?.username || storeUser?.username || 'User';
    const currentEntries = this.state.trafficEntries.length > 0
      ? this.state.trafficEntries
      : (Array.isArray(this.state.logs?.entries) ? this.state.logs.entries : []);

    const payload = {
      log_run_date: this.toUtcStartOfDayISOString(this.state.logdate),
      log_type: 'traffic',
      log_data: JSON.stringify({ entries: currentEntries }),
      verified_by: username
    };

    const existingLogId = this.getExistingLogId();

    if (existingLogId) {
      payload.id = existingLogId;
      payload._id = existingLogId;
    }

    this.setState({ isSubmitting: true, verifiedByUser: false });
    try {
      console.log('Submitting runlog payload:', payload);

      const response = await fetch(apiUrl('/runlog/save'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error saving log:', errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log('Log saved successfully');
      this.setState({ isLogSubmitted: true });
    } catch (error) {
      console.error('Error saving log data:', error);
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    const storeUser = getUser();
    const username = storeUser?.authResponse?.profile?.username || storeUser?.username || 'User';
    const isSubmitLocked = this.isSubmitLocked();
    const hasPersistedLog = Boolean(this.getExistingLogId());

    return (
    <div className="sm:ml-0 px-0 sm:px-0">
      <TitlebarWithControls title="Logs">
          <div className="flex gap-2 items-center">
            {this.state.logType === 'traffic' && (
              <>
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    checked={this.state.verifiedByUser}
                    onChange={(event) => this.setState({ verifiedByUser: event.target.checked })}
                    disabled={this.state.loading || this.state.isSubmitting}
                  />
                  Verified by ({username})
                </label>

                {/* button for saving and submitting for review */}
                <button
                  className="rounded-md bg-indigo-600 px-4 py-2 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={this.handleSaveAndSubmit}
                  disabled={
                    this.state.loading ||
                    this.state.isSubmitting ||
                    isSubmitLocked ||
                    !this.state.verifiedByUser
                  }
                >
                  {this.state.isSubmitting ? 'Saving...' : 'Save'}
                </button>

                <button
                  type="button"
                  className="rounded-md bg-indigo-600 px-4 py-2 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={this.handleUpload}
                  disabled={ !this.state.isLogSubmitted || this.state.loading || isSubmitLocked}
                >
                  Upload
                </button>
              </>
            )}

            {/* Log Type Dropdown */}
            <select
              className="rounded-md border-0 px-8 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              value={this.state.logType}
              onChange={this.handleLogTypeChange}
              disabled={this.state.loading}
            >
              <option value="traffic">Traffic</option>
              <option value="music">Music</option>
            </select>
            
            {/* Date Input */}
            <div className="relative">
              <input 
                className="rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" 
                aria-label="Date" 
                type="date" 
                value={this.state.logdate}
                onChange={this.handleDateChange}
                disabled={this.state.loading}
              />
              {this.state.loading && (
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                  <div className="animate-spin h-4 w-4 border-2 border-indigo-500 border-t-transparent rounded-full"></div>
                </div>
              )}
            </div>
          </div>
      </TitlebarWithControls>

     {/* Conditional rendering based on logType */}
      {this.state.loading ? (
        <div className="mx-4 my-4 lg:px-4 rounded-md flex justify-center items-center">
          <div className="text-center">
            <div className="animate-spin h-8 w-8 border-4 border-indigo-500 border-t-transparent rounded-full mx-auto mb-4"></div>
            <p className="text-gray-600">Loading {this.state.logType || 'traffic'} log data...</p>
          </div>
        </div>
      ) : (
        <>
          {this.state.logs !== undefined && this.state.logType === 'traffic' ? (
            <TrafficLogTable
              showtitlebar={false}
              rundate={this.state.logdate}
              hasPersistedLog={hasPersistedLog}
              logdata={this.state.logs.entries}
              onLogGenerated={(entries) => {
                this.setState({ isLogGenerated: true, hasDraggedTrafficEntry: false });
                this.handleTrafficLogUpdated(entries);
              }}
              onLogChange={this.handleTrafficLogUpdated}
              onLogReordered={() => this.setState({ hasDraggedTrafficEntry: true })}
            />
          ) : (
            // <MusicLogTable logdata={this.state.logs} />
            <MusicLogTable showtitlebar={false} logdata={this.state.logs} />
        )}
        </>
      )}

      {this.state.toastData && (
        <div className="fixed bottom-4 right-4 z-50 rounded-md bg-green-800 px-5 py-3 text-white shadow-lg">
          <p className="text-sm font-semibold mb-1">Upload Complete</p>
          <p className="text-sm"><span className="opacity-75">File:</span> {this.state.toastData.filename}</p>
          <p className="text-sm"><span className="opacity-75">Path:</span> {this.state.toastData.path?.trim()}</p>
          <p className="text-sm"><span className="opacity-75">Entries:</span> {this.state.toastData.logEntries}</p>
        </div>
      )}

      {this.state.toastMessage && (
        <div className={`fixed bottom-4 right-4 z-50 rounded-md px-4 py-2 text-sm text-white shadow-lg ${
          this.state.toastType === 'error' ? 'bg-red-600' : 'bg-indigo-600'
        }`}>
          {this.state.toastMessage}
        </div>
      )}

      </div>

    );
  }
}

export default LogTable;